// src/components/SafeImg/SafeImg.jsx
import { useState } from "react";

export default function SafeImg({
  src,
  alt = "",
  className = "",
  fallback = "/placeholder.svg",
  ...imgProps
}) {
  const [broken, setBroken] = useState(false);
  const finalSrc = broken ? fallback : src;

  return (
    <img
      src={finalSrc}
      alt={alt}
      onError={() => setBroken(true)}
      loading="lazy"
      decoding="async"
      className={className}
      {...imgProps}
    />
  );
}
